import React from 'react';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { Button, Typography } from '@guildeducationinc/recess';
import ArrowRight from '@guildeducationinc/recess/icons/ArrowForwardIcon';
import cookies from 'browser-cookies';
import { WaveIcon } from 'src/components/Quiz/Icons/WaveIcon';
import { ScreenProps } from 'src/containers/QuizContainer/types';
import { trackEvent } from 'src/services/analytics';
import styles from './OptIn.module.scss';

export const OptIn: React.FC<ScreenProps> = props => {
	const { userFromIdToken: authUser } = useMemberExperienceAuth();
	const markQuizSeen = () => {
		cookies.set('hasSeenQuiz', 'true');
	};

	return (
		<>
			<div className={styles.waveIcon}>
				<WaveIcon animated size={96} />
			</div>
			<Typography
				className={styles.greeting}
				variant='h1'
			>{`Welcome, ${authUser.firstName}!`}</Typography>
			<Typography className={styles.tellMore} variant='h5'>
				Tell us a little more about yourself, and we&apos;ll recommend programs that fit your
				interests and qualifications.
			</Typography>
			<Typography className={styles.timeExpectation} variant='h5'>
				It will take less than 2 minutes!
			</Typography>
			<div className={styles.button}>
				<Button
					icon={<ArrowRight size={18} />}
					iconDirection='right'
					onClick={() => {
						markQuizSeen();
						props.nextScreen();
						trackEvent('Clickable', {
							tag: 'InterstitialStartProgramQuiz',
							text: 'Start Program Quiz',
							type: 'button',
						});
					}}
					testid='start-button'
				>
					Get started
				</Button>
			</div>
		</>
	);
};
